import { http as base } from "@/lib/http";

export const onb = {
  state: () => base.get("/onb"),
  website: (url) => base.post("/onb/website", { url }),
  draft: () => base.post("/onb/draft"),
  confirm: () => base.post("/onb/profile/confirm"),
  editFact: (section, key, value) => base.put("/onb/profile", { section, key, value }),
  hideDoc: (id) => base.delete(`/onb/documents/${id}`),
  interview: (section) => base.get(`/onb/interview/${section}`),
  say: (section, text) => base.post(`/onb/interview/${section}/message`, { text }),
  finish: (section) => base.post(`/onb/interview/${section}/finish`),
  assign: (section, email) => base.post(`/onb/interview/${section}/assign`, { email }),
  tailor: (departments, overwrite = false) => base.post("/onb/tailor", { departments, overwrite }),
  map: () => base.get("/onb/map"),
  compare: (slug) => base.get(`/onb/roles/${slug}/compare`),
  editRole: (slug, d) => base.put(`/onb/roles/${slug}`, d),
  resetRole: (slug) => base.post(`/onb/roles/${slug}/reset`),
  regenerate: (slug, instruction) => base.post(`/onb/roles/${slug}/regenerate`, { instruction }),
  launch: (wave = 1) => base.post("/onb/launch", { wave }),
};

export async function uploadDoc(file, onProgress) {
  if (file.size > 20 * 1024 * 1024) throw new Error("Files can be up to 20 MB");
  const init = (await base.post("/onb/documents/init", { filename: file.name, size: file.size })).data;
  for (let i = 0; i < init.chunks; i++) {
    const blob = file.slice(i * init.chunk_size, (i + 1) * init.chunk_size);
    await base.put(`/onb/documents/${init.upload_id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.round(((i + 1) / init.chunks) * 90));
  }
  const doc = (await base.post(`/onb/documents/${init.upload_id}/complete`)).data;
  onProgress?.(100);
  return doc;
}

export const money = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : `${Math.round(n || 0)}`);
export const factValue = (f) => (f && typeof f === "object" && "value" in f ? f.value : f);
export const showValue = (v) => (Array.isArray(v) ? v.join(" · ") : typeof v === "object" && v ? JSON.stringify(v) : String(v ?? ""));
